import ThicknessClassName from "./ThicknessClassName";
import ThicknessClassLink from "./ThicknessClassLink";

import TimberClassName from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassName";
import TimberClassLink from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassLink";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ThicknessClassDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="ThicknessClass-detail-title"
                    >
                        { label || t`Thickness Class` }: <ThicknessClassName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="ThicknessClass-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="ThicknessClass-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } data-testid="name-label" sx={{ textAlign: "left" }}><Trans>Name</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="name-value" sx={{ textAlign: "left" }}>{ data.name || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="description-label" sx={{ textAlign: "left" }}><Trans>Description</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="description-value" sx={{ textAlign: "left" }}>{ data.description || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="minDiameter-label" sx={{ textAlign: "left" }}><Trans>Min Diameter</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="minDiameter-value" sx={{ textAlign: "left" }}>{(data.minDiameter) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="maxDiameter-label" sx={{ textAlign: "left" }}><Trans>Max Diameter</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="maxDiameter-value" sx={{ textAlign: "left" }}>{(data.maxDiameter) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="reportNameShort-label" sx={{ textAlign: "left" }}><Trans>Report Name Short</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="reportNameShort-value" sx={{ textAlign: "left" }}>{ data.reportNameShort || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="reportNameLong-label" sx={{ textAlign: "left" }}><Trans>Report Name Long</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="reportNameLong-value" sx={{ textAlign: "left" }}>{ data.reportNameLong || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="classId-label" sx={{ textAlign: "left" }}><Trans>Timber Class</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="classId-value" sx={{ textAlign: "left" }}>{ data.classId ? (<TimberClassLink id={ data.classId }/>) : '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default ThicknessClassDetail;
